/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './../../../app/routes/__root'
import { Route as AppLayoutRouteImport } from './../../../app/routes/_app/layout'
import { Route as DeniedRouteImport } from './../../../app/routes/denied'
import { Route as AppIndexRouteImport } from './../../../app/routes/_app/index'
import { Route as AppPLayoutRouteImport } from './../../../app/routes/_app/p/layout'
import { Route as AuthenticateIndexRouteImport } from './../../../app/routes/authenticate/index'
import { Route as AppPAnchorManagementLayoutRouteImport } from './../../../app/routes/_app/p/anchor-management/layout'
import { Route as AppPWhatifLayoutRouteImport } from './../../../app/routes/_app/p/whatif/layout'
import { Route as AppPAnchorManagementIndexRouteImport } from './../../../app/routes/_app/p/anchor-management/index'
import { Route as AppPAnchorManagementAnchorApprovalRouteImport } from './../../../app/routes/_app/p/anchor-management/anchor-approval'
import { Route as AppPAnchorManagementAnchorStrategyRouteImport } from './../../../app/routes/_app/p/anchor-management/anchor-strategy'
import { Route as AppPAnchorManagementAssortmentRouteImport } from './../../../app/routes/_app/p/anchor-management/assortment'
import { Route as AppPDashboardIndexRouteImport } from './../../../app/routes/_app/p/dashboard/index'
import { Route as AppPOgIndexRouteImport } from './../../../app/routes/_app/p/og/index'
import { Route as AppPOgOptimizationGroupIdLayoutRouteImport } from './../../../app/routes/_app/p/og/$optimizationGroupId/layout'
import { Route as AppPPcIndexRouteImport } from './../../../app/routes/_app/p/pc/index'
import { Route as AppPPreferencesIndexRouteImport } from './../../../app/routes/_app/p/preferences/index'
import { Route as AppPProductsIndexRouteImport } from './../../../app/routes/_app/p/products/index'
import { Route as AppPPromoIndexRouteImport } from './../../../app/routes/_app/p/promo/index'
import { Route as AppPPromoIdRouteImport } from './../../../app/routes/_app/p/promo/$id'
import { Route as AppPPromoCreateRouteImport } from './../../../app/routes/_app/p/promo/create'
import { Route as AppPTemplatesIndexRouteImport } from './../../../app/routes/_app/p/templates/index'
import { Route as AppPTemplatesTemplate_idLayoutRouteImport } from './../../../app/routes/_app/p/templates/$template_id/layout'
import { Route as AppPWhatifIndexRouteImport } from './../../../app/routes/_app/p/whatif/index'
import { Route as AppPWhatifScenariosRouteImport } from './../../../app/routes/_app/p/whatif/scenarios'
import { Route as AppPWhatifSetsRouteImport } from './../../../app/routes/_app/p/whatif/sets'
import { Route as AppPDashboardAiIndexRouteImport } from './../../../app/routes/_app/p/dashboard/ai/index'
import { Route as AppPDashboardMainIndexRouteImport } from './../../../app/routes/_app/p/dashboard/main/index'
import { Route as AppPDashboardReportsIndexRouteImport } from './../../../app/routes/_app/p/dashboard/reports/index'
import { Route as AppPOgOptimizationGroupIdProductsRouteImport } from './../../../app/routes/_app/p/og/$optimizationGroupId/products'
import { Route as AppPOgOptimizationGroupIdSettingsRouteImport } from './../../../app/routes/_app/p/og/$optimizationGroupId/settings'
import { Route as AppPTemplatesTemplate_idIndexRouteImport } from './../../../app/routes/_app/p/templates/$template_id/index'
import { Route as AppPTemplatesEditorIndexRouteImport } from './../../../app/routes/_app/p/templates/editor/index'
import { Route as AppPTemplatesEditorTemplate_idRouteImport } from './../../../app/routes/_app/p/templates/editor/$template_id'
import { Route as AppPWhatifRunsIndexRouteImport } from './../../../app/routes/_app/p/whatif/runs/index'
import { Route as AppPWhatifRunsScenarioRunSetIdSummaryRouteImport } from './../../../app/routes/_app/p/whatif/runs/$scenarioRunSetId.summary'

const AppPDataLayoutLazyRouteImport = createFileRoute('/_app/p/data')()
const AppPPricingRulesIndexLazyRouteImport = createFileRoute(
  '/_app/p/pricing-rules/',
)()
const AppPPricingRulesRuleIdLazyRouteImport = createFileRoute(
  '/_app/p/pricing-rules/$ruleId',
)()
const AppPDataCustomFeaturesIndexLazyRouteImport = createFileRoute(
  '/_app/p/data/custom-features/',
)()
const AppPDataFieldFormulaBuilderFieldIdLazyRouteImport = createFileRoute(
  '/_app/p/data/field-formula-builder/$fieldId',
)()
const AppPDataFieldSchemasIndexLazyRouteImport = createFileRoute(
  '/_app/p/data/field-schemas/',
)()

const AppLayoutRoute = AppLayoutRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DeniedRoute = DeniedRouteImport.update({
  id: '/denied',
  path: '/denied',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppPLayoutRoute = AppPLayoutRouteImport.update({
  id: '/p',
  path: '/p',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AuthenticateIndexRoute = AuthenticateIndexRouteImport.update({
  id: '/authenticate/',
  path: '/authenticate/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPAnchorManagementLayoutRoute =
  AppPAnchorManagementLayoutRouteImport.update({
    id: '/anchor-management',
    path: '/anchor-management',
    getParentRoute: () => AppPLayoutRoute,
  } as any)
const AppPDataLayoutLazyRoute = AppPDataLayoutLazyRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AppPLayoutRoute,
} as any).lazy(() =>
  import('./../../../app/routes/_app/p/data/layout.lazy').then((d) => d.Route),
)
const AppPWhatifLayoutRoute = AppPWhatifLayoutRouteImport.update({
  id: '/whatif',
  path: '/whatif',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPAnchorManagementIndexRoute =
  AppPAnchorManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPAnchorManagementLayoutRoute,
  } as any)
const AppPAnchorManagementAnchorApprovalRoute =
  AppPAnchorManagementAnchorApprovalRouteImport.update({
    id: '/anchor-approval',
    path: '/anchor-approval',
    getParentRoute: () => AppPAnchorManagementLayoutRoute,
  } as any)
const AppPAnchorManagementAnchorStrategyRoute =
  AppPAnchorManagementAnchorStrategyRouteImport.update({
    id: '/anchor-strategy',
    path: '/anchor-strategy',
    getParentRoute: () => AppPAnchorManagementLayoutRoute,
  } as any)
const AppPAnchorManagementAssortmentRoute =
  AppPAnchorManagementAssortmentRouteImport.update({
    id: '/assortment',
    path: '/assortment',
    getParentRoute: () => AppPAnchorManagementLayoutRoute,
  } as any)
const AppPDashboardIndexRoute = AppPDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPOgIndexRoute = AppPOgIndexRouteImport.update({
  id: '/og/',
  path: '/og/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPOgOptimizationGroupIdLayoutRoute =
  AppPOgOptimizationGroupIdLayoutRouteImport.update({
    id: '/og/$optimizationGroupId',
    path: '/og/$optimizationGroupId',
    getParentRoute: () => AppPLayoutRoute,
  } as any)
const AppPPcIndexRoute = AppPPcIndexRouteImport.update({
  id: '/pc/',
  path: '/pc/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPPreferencesIndexRoute = AppPPreferencesIndexRouteImport.update({
  id: '/preferences/',
  path: '/preferences/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPPricingRulesIndexLazyRoute =
  AppPPricingRulesIndexLazyRouteImport.update({
    id: '/pricing-rules/',
    path: '/pricing-rules/',
    getParentRoute: () => AppPLayoutRoute,
  } as any).lazy(() =>
    import('./../../../app/routes/_app/p/pricing-rules/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppPPricingRulesRuleIdLazyRoute =
  AppPPricingRulesRuleIdLazyRouteImport.update({
    id: '/pricing-rules/$ruleId',
    path: '/pricing-rules/$ruleId',
    getParentRoute: () => AppPLayoutRoute,
  } as any).lazy(() =>
    import('./../../../app/routes/_app/p/pricing-rules/$ruleId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppPProductsIndexRoute = AppPProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPPromoIndexRoute = AppPPromoIndexRouteImport.update({
  id: '/promo/',
  path: '/promo/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPPromoIdRoute = AppPPromoIdRouteImport.update({
  id: '/promo/$id',
  path: '/promo/$id',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPPromoCreateRoute = AppPPromoCreateRouteImport.update({
  id: '/promo/create',
  path: '/promo/create',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPTemplatesIndexRoute = AppPTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPTemplatesTemplate_idLayoutRoute =
  AppPTemplatesTemplate_idLayoutRouteImport.update({
    id: '/templates/$template_id',
    path: '/templates/$template_id',
    getParentRoute: () => AppPLayoutRoute,
  } as any)
const AppPWhatifIndexRoute = AppPWhatifIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPWhatifLayoutRoute,
} as any)
const AppPWhatifScenariosRoute = AppPWhatifScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => AppPWhatifLayoutRoute,
} as any)
const AppPWhatifSetsRoute = AppPWhatifSetsRouteImport.update({
  id: '/sets',
  path: '/sets',
  getParentRoute: () => AppPWhatifLayoutRoute,
} as any)
const AppPDashboardAiIndexRoute = AppPDashboardAiIndexRouteImport.update({
  id: '/dashboard/ai/',
  path: '/dashboard/ai/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPDashboardMainIndexRoute = AppPDashboardMainIndexRouteImport.update({
  id: '/dashboard/main/',
  path: '/dashboard/main/',
  getParentRoute: () => AppPLayoutRoute,
} as any)
const AppPDashboardReportsIndexRoute =
  AppPDashboardReportsIndexRouteImport.update({
    id: '/dashboard/reports/',
    path: '/dashboard/reports/',
    getParentRoute: () => AppPLayoutRoute,
  } as any)
const AppPDataCustomFeaturesIndexLazyRoute =
  AppPDataCustomFeaturesIndexLazyRouteImport.update({
    id: '/custom-features/',
    path: '/custom-features/',
    getParentRoute: () => AppPDataLayoutLazyRoute,
  } as any).lazy(() =>
    import('./../../../app/routes/_app/p/data/custom-features/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppPDataFieldFormulaBuilderFieldIdLazyRoute =
  AppPDataFieldFormulaBuilderFieldIdLazyRouteImport.update({
    id: '/field-formula-builder/$fieldId',
    path: '/field-formula-builder/$fieldId',
    getParentRoute: () => AppPDataLayoutLazyRoute,
  } as any).lazy(() =>
    import('./../../../app/routes/_app/p/data/field-formula-builder/$fieldId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppPDataFieldSchemasIndexLazyRoute =
  AppPDataFieldSchemasIndexLazyRouteImport.update({
    id: '/field-schemas/',
    path: '/field-schemas/',
    getParentRoute: () => AppPDataLayoutLazyRoute,
  } as any).lazy(() =>
    import('./../../../app/routes/_app/p/data/field-schemas/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppPOgOptimizationGroupIdProductsRoute =
  AppPOgOptimizationGroupIdProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AppPOgOptimizationGroupIdLayoutRoute,
  } as any)
const AppPOgOptimizationGroupIdSettingsRoute =
  AppPOgOptimizationGroupIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppPOgOptimizationGroupIdLayoutRoute,
  } as any)
const AppPTemplatesTemplate_idIndexRoute =
  AppPTemplatesTemplate_idIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPTemplatesTemplate_idLayoutRoute,
  } as any)
const AppPTemplatesEditorIndexRoute =
  AppPTemplatesEditorIndexRouteImport.update({
    id: '/templates/editor/',
    path: '/templates/editor/',
    getParentRoute: () => AppPLayoutRoute,
  } as any)
const AppPTemplatesEditorTemplate_idRoute =
  AppPTemplatesEditorTemplate_idRouteImport.update({
    id: '/templates/editor/$template_id',
    path: '/templates/editor/$template_id',
    getParentRoute: () => AppPLayoutRoute,
  } as any)
const AppPWhatifRunsIndexRoute = AppPWhatifRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AppPWhatifLayoutRoute,
} as any)
const AppPWhatifRunsScenarioRunSetIdSummaryRoute =
  AppPWhatifRunsScenarioRunSetIdSummaryRouteImport.update({
    id: '/runs/$scenarioRunSetId/summary',
    path: '/runs/$scenarioRunSetId/summary',
    getParentRoute: () => AppPWhatifLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/denied': typeof DeniedRoute
  '/p': typeof AppPLayoutRouteWithChildren
  '/authenticate/': typeof AuthenticateIndexRoute
  '/p/anchor-management': typeof AppPAnchorManagementLayoutRouteWithChildren
  '/p/whatif': typeof AppPWhatifLayoutRouteWithChildren
  '/p/data': typeof AppPDataLayoutLazyRouteWithChildren
  '/p/og/$optimizationGroupId': typeof AppPOgOptimizationGroupIdLayoutRouteWithChildren
  '/p/templates/$template_id': typeof AppPTemplatesTemplate_idLayoutRouteWithChildren
  '/p/anchor-management/anchor-approval': typeof AppPAnchorManagementAnchorApprovalRoute
  '/p/anchor-management/anchor-strategy': typeof AppPAnchorManagementAnchorStrategyRoute
  '/p/anchor-management/assortment': typeof AppPAnchorManagementAssortmentRoute
  '/p/promo/$id': typeof AppPPromoIdRoute
  '/p/promo/create': typeof AppPPromoCreateRoute
  '/p/whatif/scenarios': typeof AppPWhatifScenariosRoute
  '/p/whatif/sets': typeof AppPWhatifSetsRoute
  '/p/pricing-rules/$ruleId': typeof AppPPricingRulesRuleIdLazyRoute
  '/p/anchor-management/': typeof AppPAnchorManagementIndexRoute
  '/p/dashboard/': typeof AppPDashboardIndexRoute
  '/p/og/': typeof AppPOgIndexRoute
  '/p/pc/': typeof AppPPcIndexRoute
  '/p/preferences/': typeof AppPPreferencesIndexRoute
  '/p/products/': typeof AppPProductsIndexRoute
  '/p/promo/': typeof AppPPromoIndexRoute
  '/p/templates/': typeof AppPTemplatesIndexRoute
  '/p/whatif/': typeof AppPWhatifIndexRoute
  '/p/pricing-rules/': typeof AppPPricingRulesIndexLazyRoute
  '/p/og/$optimizationGroupId/products': typeof AppPOgOptimizationGroupIdProductsRoute
  '/p/og/$optimizationGroupId/settings': typeof AppPOgOptimizationGroupIdSettingsRoute
  '/p/templates/editor/$template_id': typeof AppPTemplatesEditorTemplate_idRoute
  '/p/data/field-formula-builder/$fieldId': typeof AppPDataFieldFormulaBuilderFieldIdLazyRoute
  '/p/dashboard/ai/': typeof AppPDashboardAiIndexRoute
  '/p/dashboard/main/': typeof AppPDashboardMainIndexRoute
  '/p/dashboard/reports/': typeof AppPDashboardReportsIndexRoute
  '/p/templates/$template_id/': typeof AppPTemplatesTemplate_idIndexRoute
  '/p/templates/editor/': typeof AppPTemplatesEditorIndexRoute
  '/p/whatif/runs/': typeof AppPWhatifRunsIndexRoute
  '/p/data/custom-features/': typeof AppPDataCustomFeaturesIndexLazyRoute
  '/p/data/field-schemas/': typeof AppPDataFieldSchemasIndexLazyRoute
  '/p/whatif/runs/$scenarioRunSetId/summary': typeof AppPWhatifRunsScenarioRunSetIdSummaryRoute
}
export interface FileRoutesByTo {
  '/denied': typeof DeniedRoute
  '/p': typeof AppPLayoutRouteWithChildren
  '/': typeof AppIndexRoute
  '/authenticate': typeof AuthenticateIndexRoute
  '/p/data': typeof AppPDataLayoutLazyRouteWithChildren
  '/p/og/$optimizationGroupId': typeof AppPOgOptimizationGroupIdLayoutRouteWithChildren
  '/p/anchor-management/anchor-approval': typeof AppPAnchorManagementAnchorApprovalRoute
  '/p/anchor-management/anchor-strategy': typeof AppPAnchorManagementAnchorStrategyRoute
  '/p/anchor-management/assortment': typeof AppPAnchorManagementAssortmentRoute
  '/p/promo/$id': typeof AppPPromoIdRoute
  '/p/promo/create': typeof AppPPromoCreateRoute
  '/p/whatif/scenarios': typeof AppPWhatifScenariosRoute
  '/p/whatif/sets': typeof AppPWhatifSetsRoute
  '/p/pricing-rules/$ruleId': typeof AppPPricingRulesRuleIdLazyRoute
  '/p/anchor-management': typeof AppPAnchorManagementIndexRoute
  '/p/dashboard': typeof AppPDashboardIndexRoute
  '/p/og': typeof AppPOgIndexRoute
  '/p/pc': typeof AppPPcIndexRoute
  '/p/preferences': typeof AppPPreferencesIndexRoute
  '/p/products': typeof AppPProductsIndexRoute
  '/p/promo': typeof AppPPromoIndexRoute
  '/p/templates': typeof AppPTemplatesIndexRoute
  '/p/whatif': typeof AppPWhatifIndexRoute
  '/p/pricing-rules': typeof AppPPricingRulesIndexLazyRoute
  '/p/og/$optimizationGroupId/products': typeof AppPOgOptimizationGroupIdProductsRoute
  '/p/og/$optimizationGroupId/settings': typeof AppPOgOptimizationGroupIdSettingsRoute
  '/p/templates/editor/$template_id': typeof AppPTemplatesEditorTemplate_idRoute
  '/p/data/field-formula-builder/$fieldId': typeof AppPDataFieldFormulaBuilderFieldIdLazyRoute
  '/p/dashboard/ai': typeof AppPDashboardAiIndexRoute
  '/p/dashboard/main': typeof AppPDashboardMainIndexRoute
  '/p/dashboard/reports': typeof AppPDashboardReportsIndexRoute
  '/p/templates/$template_id': typeof AppPTemplatesTemplate_idIndexRoute
  '/p/templates/editor': typeof AppPTemplatesEditorIndexRoute
  '/p/whatif/runs': typeof AppPWhatifRunsIndexRoute
  '/p/data/custom-features': typeof AppPDataCustomFeaturesIndexLazyRoute
  '/p/data/field-schemas': typeof AppPDataFieldSchemasIndexLazyRoute
  '/p/whatif/runs/$scenarioRunSetId/summary': typeof AppPWhatifRunsScenarioRunSetIdSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppLayoutRouteWithChildren
  '/denied': typeof DeniedRoute
  '/_app/p': typeof AppPLayoutRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/authenticate/': typeof AuthenticateIndexRoute
  '/_app/p/anchor-management': typeof AppPAnchorManagementLayoutRouteWithChildren
  '/_app/p/whatif': typeof AppPWhatifLayoutRouteWithChildren
  '/_app/p/data': typeof AppPDataLayoutLazyRouteWithChildren
  '/_app/p/og/$optimizationGroupId': typeof AppPOgOptimizationGroupIdLayoutRouteWithChildren
  '/_app/p/templates/$template_id': typeof AppPTemplatesTemplate_idLayoutRouteWithChildren
  '/_app/p/anchor-management/anchor-approval': typeof AppPAnchorManagementAnchorApprovalRoute
  '/_app/p/anchor-management/anchor-strategy': typeof AppPAnchorManagementAnchorStrategyRoute
  '/_app/p/anchor-management/assortment': typeof AppPAnchorManagementAssortmentRoute
  '/_app/p/promo/$id': typeof AppPPromoIdRoute
  '/_app/p/promo/create': typeof AppPPromoCreateRoute
  '/_app/p/whatif/scenarios': typeof AppPWhatifScenariosRoute
  '/_app/p/whatif/sets': typeof AppPWhatifSetsRoute
  '/_app/p/pricing-rules/$ruleId': typeof AppPPricingRulesRuleIdLazyRoute
  '/_app/p/anchor-management/': typeof AppPAnchorManagementIndexRoute
  '/_app/p/dashboard/': typeof AppPDashboardIndexRoute
  '/_app/p/og/': typeof AppPOgIndexRoute
  '/_app/p/pc/': typeof AppPPcIndexRoute
  '/_app/p/preferences/': typeof AppPPreferencesIndexRoute
  '/_app/p/products/': typeof AppPProductsIndexRoute
  '/_app/p/promo/': typeof AppPPromoIndexRoute
  '/_app/p/templates/': typeof AppPTemplatesIndexRoute
  '/_app/p/whatif/': typeof AppPWhatifIndexRoute
  '/_app/p/pricing-rules/': typeof AppPPricingRulesIndexLazyRoute
  '/_app/p/og/$optimizationGroupId/products': typeof AppPOgOptimizationGroupIdProductsRoute
  '/_app/p/og/$optimizationGroupId/settings': typeof AppPOgOptimizationGroupIdSettingsRoute
  '/_app/p/templates/editor/$template_id': typeof AppPTemplatesEditorTemplate_idRoute
  '/_app/p/data/field-formula-builder/$fieldId': typeof AppPDataFieldFormulaBuilderFieldIdLazyRoute
  '/_app/p/dashboard/ai/': typeof AppPDashboardAiIndexRoute
  '/_app/p/dashboard/main/': typeof AppPDashboardMainIndexRoute
  '/_app/p/dashboard/reports/': typeof AppPDashboardReportsIndexRoute
  '/_app/p/templates/$template_id/': typeof AppPTemplatesTemplate_idIndexRoute
  '/_app/p/templates/editor/': typeof AppPTemplatesEditorIndexRoute
  '/_app/p/whatif/runs/': typeof AppPWhatifRunsIndexRoute
  '/_app/p/data/custom-features/': typeof AppPDataCustomFeaturesIndexLazyRoute
  '/_app/p/data/field-schemas/': typeof AppPDataFieldSchemasIndexLazyRoute
  '/_app/p/whatif/runs/$scenarioRunSetId/summary': typeof AppPWhatifRunsScenarioRunSetIdSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/denied'
    | '/p'
    | '/authenticate/'
    | '/p/anchor-management'
    | '/p/whatif'
    | '/p/data'
    | '/p/og/$optimizationGroupId'
    | '/p/templates/$template_id'
    | '/p/anchor-management/anchor-approval'
    | '/p/anchor-management/anchor-strategy'
    | '/p/anchor-management/assortment'
    | '/p/promo/$id'
    | '/p/promo/create'
    | '/p/whatif/scenarios'
    | '/p/whatif/sets'
    | '/p/pricing-rules/$ruleId'
    | '/p/anchor-management/'
    | '/p/dashboard/'
    | '/p/og/'
    | '/p/pc/'
    | '/p/preferences/'
    | '/p/products/'
    | '/p/promo/'
    | '/p/templates/'
    | '/p/whatif/'
    | '/p/pricing-rules/'
    | '/p/og/$optimizationGroupId/products'
    | '/p/og/$optimizationGroupId/settings'
    | '/p/templates/editor/$template_id'
    | '/p/data/field-formula-builder/$fieldId'
    | '/p/dashboard/ai/'
    | '/p/dashboard/main/'
    | '/p/dashboard/reports/'
    | '/p/templates/$template_id/'
    | '/p/templates/editor/'
    | '/p/whatif/runs/'
    | '/p/data/custom-features/'
    | '/p/data/field-schemas/'
    | '/p/whatif/runs/$scenarioRunSetId/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/denied'
    | '/p'
    | '/'
    | '/authenticate'
    | '/p/data'
    | '/p/og/$optimizationGroupId'
    | '/p/anchor-management/anchor-approval'
    | '/p/anchor-management/anchor-strategy'
    | '/p/anchor-management/assortment'
    | '/p/promo/$id'
    | '/p/promo/create'
    | '/p/whatif/scenarios'
    | '/p/whatif/sets'
    | '/p/pricing-rules/$ruleId'
    | '/p/anchor-management'
    | '/p/dashboard'
    | '/p/og'
    | '/p/pc'
    | '/p/preferences'
    | '/p/products'
    | '/p/promo'
    | '/p/templates'
    | '/p/whatif'
    | '/p/pricing-rules'
    | '/p/og/$optimizationGroupId/products'
    | '/p/og/$optimizationGroupId/settings'
    | '/p/templates/editor/$template_id'
    | '/p/data/field-formula-builder/$fieldId'
    | '/p/dashboard/ai'
    | '/p/dashboard/main'
    | '/p/dashboard/reports'
    | '/p/templates/$template_id'
    | '/p/templates/editor'
    | '/p/whatif/runs'
    | '/p/data/custom-features'
    | '/p/data/field-schemas'
    | '/p/whatif/runs/$scenarioRunSetId/summary'
  id:
    | '__root__'
    | '/_app'
    | '/denied'
    | '/_app/p'
    | '/_app/'
    | '/authenticate/'
    | '/_app/p/anchor-management'
    | '/_app/p/whatif'
    | '/_app/p/data'
    | '/_app/p/og/$optimizationGroupId'
    | '/_app/p/templates/$template_id'
    | '/_app/p/anchor-management/anchor-approval'
    | '/_app/p/anchor-management/anchor-strategy'
    | '/_app/p/anchor-management/assortment'
    | '/_app/p/promo/$id'
    | '/_app/p/promo/create'
    | '/_app/p/whatif/scenarios'
    | '/_app/p/whatif/sets'
    | '/_app/p/pricing-rules/$ruleId'
    | '/_app/p/anchor-management/'
    | '/_app/p/dashboard/'
    | '/_app/p/og/'
    | '/_app/p/pc/'
    | '/_app/p/preferences/'
    | '/_app/p/products/'
    | '/_app/p/promo/'
    | '/_app/p/templates/'
    | '/_app/p/whatif/'
    | '/_app/p/pricing-rules/'
    | '/_app/p/og/$optimizationGroupId/products'
    | '/_app/p/og/$optimizationGroupId/settings'
    | '/_app/p/templates/editor/$template_id'
    | '/_app/p/data/field-formula-builder/$fieldId'
    | '/_app/p/dashboard/ai/'
    | '/_app/p/dashboard/main/'
    | '/_app/p/dashboard/reports/'
    | '/_app/p/templates/$template_id/'
    | '/_app/p/templates/editor/'
    | '/_app/p/whatif/runs/'
    | '/_app/p/data/custom-features/'
    | '/_app/p/data/field-schemas/'
    | '/_app/p/whatif/runs/$scenarioRunSetId/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppLayoutRoute: typeof AppLayoutRouteWithChildren
  DeniedRoute: typeof DeniedRoute
  AuthenticateIndexRoute: typeof AuthenticateIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/denied': {
      id: '/denied'
      path: '/denied'
      fullPath: '/denied'
      preLoaderRoute: typeof DeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/_app/p': {
      id: '/_app/p'
      path: '/p'
      fullPath: '/p'
      preLoaderRoute: typeof AppPLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/authenticate/': {
      id: '/authenticate/'
      path: '/authenticate'
      fullPath: '/authenticate/'
      preLoaderRoute: typeof AuthenticateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/p/anchor-management': {
      id: '/_app/p/anchor-management'
      path: '/anchor-management'
      fullPath: '/p/anchor-management'
      preLoaderRoute: typeof AppPAnchorManagementLayoutRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/data': {
      id: '/_app/p/data'
      path: '/data'
      fullPath: '/p/data'
      preLoaderRoute: typeof AppPDataLayoutLazyRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/whatif': {
      id: '/_app/p/whatif'
      path: '/whatif'
      fullPath: '/p/whatif'
      preLoaderRoute: typeof AppPWhatifLayoutRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/anchor-management/': {
      id: '/_app/p/anchor-management/'
      path: '/'
      fullPath: '/p/anchor-management/'
      preLoaderRoute: typeof AppPAnchorManagementIndexRouteImport
      parentRoute: typeof AppPAnchorManagementLayoutRoute
    }
    '/_app/p/anchor-management/anchor-approval': {
      id: '/_app/p/anchor-management/anchor-approval'
      path: '/anchor-approval'
      fullPath: '/p/anchor-management/anchor-approval'
      preLoaderRoute: typeof AppPAnchorManagementAnchorApprovalRouteImport
      parentRoute: typeof AppPAnchorManagementLayoutRoute
    }
    '/_app/p/anchor-management/anchor-strategy': {
      id: '/_app/p/anchor-management/anchor-strategy'
      path: '/anchor-strategy'
      fullPath: '/p/anchor-management/anchor-strategy'
      preLoaderRoute: typeof AppPAnchorManagementAnchorStrategyRouteImport
      parentRoute: typeof AppPAnchorManagementLayoutRoute
    }
    '/_app/p/anchor-management/assortment': {
      id: '/_app/p/anchor-management/assortment'
      path: '/assortment'
      fullPath: '/p/anchor-management/assortment'
      preLoaderRoute: typeof AppPAnchorManagementAssortmentRouteImport
      parentRoute: typeof AppPAnchorManagementLayoutRoute
    }
    '/_app/p/dashboard/': {
      id: '/_app/p/dashboard/'
      path: '/dashboard'
      fullPath: '/p/dashboard/'
      preLoaderRoute: typeof AppPDashboardIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/og/': {
      id: '/_app/p/og/'
      path: '/og'
      fullPath: '/p/og/'
      preLoaderRoute: typeof AppPOgIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/og/$optimizationGroupId': {
      id: '/_app/p/og/$optimizationGroupId'
      path: '/og/$optimizationGroupId'
      fullPath: '/p/og/$optimizationGroupId'
      preLoaderRoute: typeof AppPOgOptimizationGroupIdLayoutRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/pc/': {
      id: '/_app/p/pc/'
      path: '/pc'
      fullPath: '/p/pc/'
      preLoaderRoute: typeof AppPPcIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/preferences/': {
      id: '/_app/p/preferences/'
      path: '/preferences'
      fullPath: '/p/preferences/'
      preLoaderRoute: typeof AppPPreferencesIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/pricing-rules/': {
      id: '/_app/p/pricing-rules/'
      path: '/pricing-rules'
      fullPath: '/p/pricing-rules/'
      preLoaderRoute: typeof AppPPricingRulesIndexLazyRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/pricing-rules/$ruleId': {
      id: '/_app/p/pricing-rules/$ruleId'
      path: '/pricing-rules/$ruleId'
      fullPath: '/p/pricing-rules/$ruleId'
      preLoaderRoute: typeof AppPPricingRulesRuleIdLazyRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/products/': {
      id: '/_app/p/products/'
      path: '/products'
      fullPath: '/p/products/'
      preLoaderRoute: typeof AppPProductsIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/promo/': {
      id: '/_app/p/promo/'
      path: '/promo'
      fullPath: '/p/promo/'
      preLoaderRoute: typeof AppPPromoIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/promo/$id': {
      id: '/_app/p/promo/$id'
      path: '/promo/$id'
      fullPath: '/p/promo/$id'
      preLoaderRoute: typeof AppPPromoIdRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/promo/create': {
      id: '/_app/p/promo/create'
      path: '/promo/create'
      fullPath: '/p/promo/create'
      preLoaderRoute: typeof AppPPromoCreateRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/templates/': {
      id: '/_app/p/templates/'
      path: '/templates'
      fullPath: '/p/templates/'
      preLoaderRoute: typeof AppPTemplatesIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/templates/$template_id': {
      id: '/_app/p/templates/$template_id'
      path: '/templates/$template_id'
      fullPath: '/p/templates/$template_id'
      preLoaderRoute: typeof AppPTemplatesTemplate_idLayoutRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/whatif/': {
      id: '/_app/p/whatif/'
      path: '/'
      fullPath: '/p/whatif/'
      preLoaderRoute: typeof AppPWhatifIndexRouteImport
      parentRoute: typeof AppPWhatifLayoutRoute
    }
    '/_app/p/whatif/scenarios': {
      id: '/_app/p/whatif/scenarios'
      path: '/scenarios'
      fullPath: '/p/whatif/scenarios'
      preLoaderRoute: typeof AppPWhatifScenariosRouteImport
      parentRoute: typeof AppPWhatifLayoutRoute
    }
    '/_app/p/whatif/sets': {
      id: '/_app/p/whatif/sets'
      path: '/sets'
      fullPath: '/p/whatif/sets'
      preLoaderRoute: typeof AppPWhatifSetsRouteImport
      parentRoute: typeof AppPWhatifLayoutRoute
    }
    '/_app/p/dashboard/ai/': {
      id: '/_app/p/dashboard/ai/'
      path: '/dashboard/ai'
      fullPath: '/p/dashboard/ai/'
      preLoaderRoute: typeof AppPDashboardAiIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/dashboard/main/': {
      id: '/_app/p/dashboard/main/'
      path: '/dashboard/main'
      fullPath: '/p/dashboard/main/'
      preLoaderRoute: typeof AppPDashboardMainIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/dashboard/reports/': {
      id: '/_app/p/dashboard/reports/'
      path: '/dashboard/reports'
      fullPath: '/p/dashboard/reports/'
      preLoaderRoute: typeof AppPDashboardReportsIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/data/custom-features/': {
      id: '/_app/p/data/custom-features/'
      path: '/custom-features'
      fullPath: '/p/data/custom-features/'
      preLoaderRoute: typeof AppPDataCustomFeaturesIndexLazyRouteImport
      parentRoute: typeof AppPDataLayoutLazyRoute
    }
    '/_app/p/data/field-formula-builder/$fieldId': {
      id: '/_app/p/data/field-formula-builder/$fieldId'
      path: '/field-formula-builder/$fieldId'
      fullPath: '/p/data/field-formula-builder/$fieldId'
      preLoaderRoute: typeof AppPDataFieldFormulaBuilderFieldIdLazyRouteImport
      parentRoute: typeof AppPDataLayoutLazyRoute
    }
    '/_app/p/data/field-schemas/': {
      id: '/_app/p/data/field-schemas/'
      path: '/field-schemas'
      fullPath: '/p/data/field-schemas/'
      preLoaderRoute: typeof AppPDataFieldSchemasIndexLazyRouteImport
      parentRoute: typeof AppPDataLayoutLazyRoute
    }
    '/_app/p/og/$optimizationGroupId/products': {
      id: '/_app/p/og/$optimizationGroupId/products'
      path: '/products'
      fullPath: '/p/og/$optimizationGroupId/products'
      preLoaderRoute: typeof AppPOgOptimizationGroupIdProductsRouteImport
      parentRoute: typeof AppPOgOptimizationGroupIdLayoutRoute
    }
    '/_app/p/og/$optimizationGroupId/settings': {
      id: '/_app/p/og/$optimizationGroupId/settings'
      path: '/settings'
      fullPath: '/p/og/$optimizationGroupId/settings'
      preLoaderRoute: typeof AppPOgOptimizationGroupIdSettingsRouteImport
      parentRoute: typeof AppPOgOptimizationGroupIdLayoutRoute
    }
    '/_app/p/templates/$template_id/': {
      id: '/_app/p/templates/$template_id/'
      path: '/'
      fullPath: '/p/templates/$template_id/'
      preLoaderRoute: typeof AppPTemplatesTemplate_idIndexRouteImport
      parentRoute: typeof AppPTemplatesTemplate_idLayoutRoute
    }
    '/_app/p/templates/editor/': {
      id: '/_app/p/templates/editor/'
      path: '/templates/editor'
      fullPath: '/p/templates/editor/'
      preLoaderRoute: typeof AppPTemplatesEditorIndexRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/templates/editor/$template_id': {
      id: '/_app/p/templates/editor/$template_id'
      path: '/templates/editor/$template_id'
      fullPath: '/p/templates/editor/$template_id'
      preLoaderRoute: typeof AppPTemplatesEditorTemplate_idRouteImport
      parentRoute: typeof AppPLayoutRoute
    }
    '/_app/p/whatif/runs/': {
      id: '/_app/p/whatif/runs/'
      path: '/runs'
      fullPath: '/p/whatif/runs/'
      preLoaderRoute: typeof AppPWhatifRunsIndexRouteImport
      parentRoute: typeof AppPWhatifLayoutRoute
    }
    '/_app/p/whatif/runs/$scenarioRunSetId/summary': {
      id: '/_app/p/whatif/runs/$scenarioRunSetId/summary'
      path: '/runs/$scenarioRunSetId/summary'
      fullPath: '/p/whatif/runs/$scenarioRunSetId/summary'
      preLoaderRoute: typeof AppPWhatifRunsScenarioRunSetIdSummaryRouteImport
      parentRoute: typeof AppPWhatifLayoutRoute
    }
  }
}

interface AppPAnchorManagementLayoutRouteChildren {
  AppPAnchorManagementAnchorApprovalRoute: typeof AppPAnchorManagementAnchorApprovalRoute
  AppPAnchorManagementAnchorStrategyRoute: typeof AppPAnchorManagementAnchorStrategyRoute
  AppPAnchorManagementAssortmentRoute: typeof AppPAnchorManagementAssortmentRoute
  AppPAnchorManagementIndexRoute: typeof AppPAnchorManagementIndexRoute
}

const AppPAnchorManagementLayoutRouteChildren: AppPAnchorManagementLayoutRouteChildren =
  {
    AppPAnchorManagementAnchorApprovalRoute:
      AppPAnchorManagementAnchorApprovalRoute,
    AppPAnchorManagementAnchorStrategyRoute:
      AppPAnchorManagementAnchorStrategyRoute,
    AppPAnchorManagementAssortmentRoute: AppPAnchorManagementAssortmentRoute,
    AppPAnchorManagementIndexRoute: AppPAnchorManagementIndexRoute,
  }

const AppPAnchorManagementLayoutRouteWithChildren =
  AppPAnchorManagementLayoutRoute._addFileChildren(
    AppPAnchorManagementLayoutRouteChildren,
  )

interface AppPWhatifLayoutRouteChildren {
  AppPWhatifScenariosRoute: typeof AppPWhatifScenariosRoute
  AppPWhatifSetsRoute: typeof AppPWhatifSetsRoute
  AppPWhatifIndexRoute: typeof AppPWhatifIndexRoute
  AppPWhatifRunsIndexRoute: typeof AppPWhatifRunsIndexRoute
  AppPWhatifRunsScenarioRunSetIdSummaryRoute: typeof AppPWhatifRunsScenarioRunSetIdSummaryRoute
}

const AppPWhatifLayoutRouteChildren: AppPWhatifLayoutRouteChildren = {
  AppPWhatifScenariosRoute: AppPWhatifScenariosRoute,
  AppPWhatifSetsRoute: AppPWhatifSetsRoute,
  AppPWhatifIndexRoute: AppPWhatifIndexRoute,
  AppPWhatifRunsIndexRoute: AppPWhatifRunsIndexRoute,
  AppPWhatifRunsScenarioRunSetIdSummaryRoute:
    AppPWhatifRunsScenarioRunSetIdSummaryRoute,
}

const AppPWhatifLayoutRouteWithChildren =
  AppPWhatifLayoutRoute._addFileChildren(AppPWhatifLayoutRouteChildren)

interface AppPDataLayoutLazyRouteChildren {
  AppPDataFieldFormulaBuilderFieldIdLazyRoute: typeof AppPDataFieldFormulaBuilderFieldIdLazyRoute
  AppPDataCustomFeaturesIndexLazyRoute: typeof AppPDataCustomFeaturesIndexLazyRoute
  AppPDataFieldSchemasIndexLazyRoute: typeof AppPDataFieldSchemasIndexLazyRoute
}

const AppPDataLayoutLazyRouteChildren: AppPDataLayoutLazyRouteChildren = {
  AppPDataFieldFormulaBuilderFieldIdLazyRoute:
    AppPDataFieldFormulaBuilderFieldIdLazyRoute,
  AppPDataCustomFeaturesIndexLazyRoute: AppPDataCustomFeaturesIndexLazyRoute,
  AppPDataFieldSchemasIndexLazyRoute: AppPDataFieldSchemasIndexLazyRoute,
}

const AppPDataLayoutLazyRouteWithChildren =
  AppPDataLayoutLazyRoute._addFileChildren(AppPDataLayoutLazyRouteChildren)

interface AppPOgOptimizationGroupIdLayoutRouteChildren {
  AppPOgOptimizationGroupIdProductsRoute: typeof AppPOgOptimizationGroupIdProductsRoute
  AppPOgOptimizationGroupIdSettingsRoute: typeof AppPOgOptimizationGroupIdSettingsRoute
}

const AppPOgOptimizationGroupIdLayoutRouteChildren: AppPOgOptimizationGroupIdLayoutRouteChildren =
  {
    AppPOgOptimizationGroupIdProductsRoute:
      AppPOgOptimizationGroupIdProductsRoute,
    AppPOgOptimizationGroupIdSettingsRoute:
      AppPOgOptimizationGroupIdSettingsRoute,
  }

const AppPOgOptimizationGroupIdLayoutRouteWithChildren =
  AppPOgOptimizationGroupIdLayoutRoute._addFileChildren(
    AppPOgOptimizationGroupIdLayoutRouteChildren,
  )

interface AppPTemplatesTemplate_idLayoutRouteChildren {
  AppPTemplatesTemplate_idIndexRoute: typeof AppPTemplatesTemplate_idIndexRoute
}

const AppPTemplatesTemplate_idLayoutRouteChildren: AppPTemplatesTemplate_idLayoutRouteChildren =
  {
    AppPTemplatesTemplate_idIndexRoute: AppPTemplatesTemplate_idIndexRoute,
  }

const AppPTemplatesTemplate_idLayoutRouteWithChildren =
  AppPTemplatesTemplate_idLayoutRoute._addFileChildren(
    AppPTemplatesTemplate_idLayoutRouteChildren,
  )

interface AppPLayoutRouteChildren {
  AppPAnchorManagementLayoutRoute: typeof AppPAnchorManagementLayoutRouteWithChildren
  AppPWhatifLayoutRoute: typeof AppPWhatifLayoutRouteWithChildren
  AppPDataLayoutLazyRoute: typeof AppPDataLayoutLazyRouteWithChildren
  AppPOgOptimizationGroupIdLayoutRoute: typeof AppPOgOptimizationGroupIdLayoutRouteWithChildren
  AppPTemplatesTemplate_idLayoutRoute: typeof AppPTemplatesTemplate_idLayoutRouteWithChildren
  AppPPromoIdRoute: typeof AppPPromoIdRoute
  AppPPromoCreateRoute: typeof AppPPromoCreateRoute
  AppPPricingRulesRuleIdLazyRoute: typeof AppPPricingRulesRuleIdLazyRoute
  AppPDashboardIndexRoute: typeof AppPDashboardIndexRoute
  AppPOgIndexRoute: typeof AppPOgIndexRoute
  AppPPcIndexRoute: typeof AppPPcIndexRoute
  AppPPreferencesIndexRoute: typeof AppPPreferencesIndexRoute
  AppPProductsIndexRoute: typeof AppPProductsIndexRoute
  AppPPromoIndexRoute: typeof AppPPromoIndexRoute
  AppPTemplatesIndexRoute: typeof AppPTemplatesIndexRoute
  AppPPricingRulesIndexLazyRoute: typeof AppPPricingRulesIndexLazyRoute
  AppPTemplatesEditorTemplate_idRoute: typeof AppPTemplatesEditorTemplate_idRoute
  AppPDashboardAiIndexRoute: typeof AppPDashboardAiIndexRoute
  AppPDashboardMainIndexRoute: typeof AppPDashboardMainIndexRoute
  AppPDashboardReportsIndexRoute: typeof AppPDashboardReportsIndexRoute
  AppPTemplatesEditorIndexRoute: typeof AppPTemplatesEditorIndexRoute
}

const AppPLayoutRouteChildren: AppPLayoutRouteChildren = {
  AppPAnchorManagementLayoutRoute: AppPAnchorManagementLayoutRouteWithChildren,
  AppPWhatifLayoutRoute: AppPWhatifLayoutRouteWithChildren,
  AppPDataLayoutLazyRoute: AppPDataLayoutLazyRouteWithChildren,
  AppPOgOptimizationGroupIdLayoutRoute:
    AppPOgOptimizationGroupIdLayoutRouteWithChildren,
  AppPTemplatesTemplate_idLayoutRoute:
    AppPTemplatesTemplate_idLayoutRouteWithChildren,
  AppPPromoIdRoute: AppPPromoIdRoute,
  AppPPromoCreateRoute: AppPPromoCreateRoute,
  AppPPricingRulesRuleIdLazyRoute: AppPPricingRulesRuleIdLazyRoute,
  AppPDashboardIndexRoute: AppPDashboardIndexRoute,
  AppPOgIndexRoute: AppPOgIndexRoute,
  AppPPcIndexRoute: AppPPcIndexRoute,
  AppPPreferencesIndexRoute: AppPPreferencesIndexRoute,
  AppPProductsIndexRoute: AppPProductsIndexRoute,
  AppPPromoIndexRoute: AppPPromoIndexRoute,
  AppPTemplatesIndexRoute: AppPTemplatesIndexRoute,
  AppPPricingRulesIndexLazyRoute: AppPPricingRulesIndexLazyRoute,
  AppPTemplatesEditorTemplate_idRoute: AppPTemplatesEditorTemplate_idRoute,
  AppPDashboardAiIndexRoute: AppPDashboardAiIndexRoute,
  AppPDashboardMainIndexRoute: AppPDashboardMainIndexRoute,
  AppPDashboardReportsIndexRoute: AppPDashboardReportsIndexRoute,
  AppPTemplatesEditorIndexRoute: AppPTemplatesEditorIndexRoute,
}

const AppPLayoutRouteWithChildren = AppPLayoutRoute._addFileChildren(
  AppPLayoutRouteChildren,
)

interface AppLayoutRouteChildren {
  AppPLayoutRoute: typeof AppPLayoutRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppLayoutRouteChildren: AppLayoutRouteChildren = {
  AppPLayoutRoute: AppPLayoutRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppLayoutRouteWithChildren = AppLayoutRoute._addFileChildren(
  AppLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppLayoutRoute: AppLayoutRouteWithChildren,
  DeniedRoute: DeniedRoute,
  AuthenticateIndexRoute: AuthenticateIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
